import { action, createRequestTypes } from './base';

export const offerActionTypes = {
  CREATE_OFFER: createRequestTypes('CREATE_OFFER'),
  GET_OFFER_BY_ID: createRequestTypes('GET_OFFER_BY_ID'),
  GET_OFFER_BY_TENANT_SKU: createRequestTypes('GET_OFFER_BY_TENANT_SKU'),
  GET_OFFERS: createRequestTypes('GET_OFFERS'),
  GET_ALL_SELLER_OFFERS: createRequestTypes('GET_ALL_SELLER_OFFERS'),
  DELETE_OFFER: createRequestTypes('DELETE_OFFER'),
  UPDATE_OFFER: createRequestTypes('UPDATE_OFFER'),
  GET_OFFER_BY_SKU: createRequestTypes('GET_OFFER_BY_SKU'),
  GET_SELLING_PRICE: createRequestTypes('GET_SELLING_PRICE'),
  CREATE_SELLING_PRICE: createRequestTypes('CREATE_SELLING_PRICE'),
  UPDATE_SELLING_PRICE: createRequestTypes('UPDATE_SELLING_PRICE'),
  ARCHIVE_OFFER_PRICE: createRequestTypes('ARCHIVE_OFFER_PRICE'),
};

/**
 *
 */
class OfferActions {
  /**
   * @param payload
   * @param callback
   * @param getOffersAgain
   * @param skuId
   * @return {{type: *}}
   */
  createOffer = (payload, callback, getOffersAgain, skuId) => action(offerActionTypes.CREATE_OFFER.REQUEST, {
    payload,
    callback,
    getOffersAgain,
    skuId,
  })

  /**
   *
   * @param createOfferLoading
   * @return {{type: *}}
   */
  createOfferLoading = (createOfferLoading) => action(offerActionTypes.CREATE_OFFER.LOADING, {
    createOfferLoading,
  })

  /**
   *
   * @param createdOffer
   * @return {{type: *}}
   */
  createOfferSuccess = (createdOffer) => action(offerActionTypes.CREATE_OFFER.SUCCESS, {
    createdOffer,
  })

  /**
   *
   * @param offerId
   * @return {{type: *}}
   */
  getOfferById = (offerId) => action(offerActionTypes.GET_OFFER_BY_ID.REQUEST, {
    offerId,
  })

  /**
   *
   * @param getOfferByIdLoading
   * @return {{type: *}}
   */
  getOfferByIdLoading = (getOfferByIdLoading) => action(offerActionTypes.GET_OFFER_BY_ID.LOADING, {
    getOfferByIdLoading,
  });

  /**
   *
   * @param selectedOffer
   * @return {{type: *}}
   */
  getOfferByIdSuccess = (selectedOffer) => action(offerActionTypes.GET_OFFER_BY_ID.SUCCESS, {
    selectedOffer,
  })

  /**
   *
   * @param tenantProductId
   * @param tenantSellerId
   * @return {{type: *}}
   */
  getOffers = (tenantProductId, tenantSellerId) => action(offerActionTypes.GET_OFFERS.REQUEST, {
    tenantProductId, tenantSellerId,
  })

  /**
   *
   * @param getOffersLoading
   * @return {{type: *}}
   */
  getOffersLoading = (getOffersLoading) => action(offerActionTypes.GET_OFFERS.LOADING, {
    getOffersLoading,
  })

  /**
   *
   * @param offers
   * @return {{type: *}}
   */
  getOffersSuccess = (offers) => action(offerActionTypes.GET_OFFERS.SUCCESS, {
    offers,
  })

  /**
   *
   * @param productSkuId
   * @param page
   * @param limit
   * @returns {{type: *}}
   */
  getAllSellerOffers = (productSkuId, tenantIds, page, limit, sellerId, callback) => action(offerActionTypes.GET_ALL_SELLER_OFFERS.REQUEST, {
    productSkuId, tenantIds, page, limit, sellerId, callback,
  })

  /**
   *
   * @param getAllSellerOffersLoading
   * @returns {{type: *}}
   */
  getAllSellerOffersLoading = (getAllSellerOffersLoading) => action(offerActionTypes.GET_ALL_SELLER_OFFERS.LOADING, {
    getAllSellerOffersLoading,
  })

  /**
   *
   * @param allSellerOffers
   * @returns {{type: *}}
   */
  getAllSellerOffersSuccess = (allSellerOffers) => action(offerActionTypes.GET_ALL_SELLER_OFFERS.SUCCESS, {
    allSellerOffers,
  })

  /**
   * @param sellerId
   * @param page
   * @return {{type: *}}
   */
  getOffersBySku = (sellerId, page) => action(offerActionTypes.GET_OFFER_BY_SKU.REQUEST, {
    sellerId,
    page,
  })

  /**
   *
   * @param getOffersBySkuLoading
   * @return {{type: *}}
   */
  getOffersBySkuLoading = (getOffersBySkuLoading) => action(offerActionTypes.GET_OFFER_BY_SKU.LOADING, {
    getOffersBySkuLoading,
  })

  /**
   * @param sellerOffers
   * @param offers
   * @return {{type: *}}
   */
  getOffersBySkuSuccess = (sellerOffers) => action(offerActionTypes.GET_OFFER_BY_SKU.SUCCESS, {
    sellerOffers,
  })

  /**
   *
   * @param tenantProductId
   * @param tenantSellerId
   * @param callback
   * @return {{type: *}}
   */
  getOfferByTenantSku = (tenantProductId, tenantSellerId, callback, tenantProductIds) => action(offerActionTypes.GET_OFFER_BY_TENANT_SKU.REQUEST, {
    tenantProductId, tenantSellerId, callback, tenantProductIds,
  })

  /**
   *
   * @param getOfferByTenantSkuLoading
   * @return {{type: *}}
   */
  getOfferByTenantSkuLoading = (getOfferByTenantSkuLoading) => action(offerActionTypes.GET_OFFER_BY_TENANT_SKU.LOADING, {
    getOfferByTenantSkuLoading,
  })

  /**
   *
   * @param tenantSkuOffer
   * @return {{type: *}}
   */
  getOfferByTenantSkuSuccess = (tenantSkuOffer) => action(offerActionTypes.GET_OFFER_BY_TENANT_SKU.SUCCESS, {
    tenantSkuOffer,
  })

  /**
   * @param offerId
   * @param skuId
   * @return {{type: *}}
   */
  deleteOffer = (offerId, skuId) => action(offerActionTypes.DELETE_OFFER.REQUEST, {
    offerId,
    skuId,
  })

  /**
   *
   * @param deleteOfferLoading
   * @return {{type: *}}
   */
  deleteOfferLoading = (deleteOfferLoading) => action(offerActionTypes.DELETE_OFFER.LOADING, {
    deleteOfferLoading,
  })

  /**
   * @param payload
   * @param history
   * @param toggleShowEditModal
   * @param callback
   * @return {{type: *}}
   */
  updateOffer = (payload, history, toggleShowEditModal, callback) => action(offerActionTypes.UPDATE_OFFER.REQUEST, {
    payload,
    history,
    toggleShowEditModal,
    callback,
  })

  /**
   *
   * @param updateOfferLoading
   * @return {{type: *}}
   */
  updateOfferLoading = (updateOfferLoading) => action(offerActionTypes.UPDATE_OFFER.LOADING, {
    updateOfferLoading,
  })

  /**
   * @param sellingPriceId
   * @param orgId
   * @param tenantId
   * @param skuId
   * @param quantity
   * @param page
   * @param limit
   * @param offerId
   * @return {{type: *}}
   */
  getSellingPrices = (sellingPriceId, orgId, tenantId, skuId, quantity, page, limit) => action(offerActionTypes.GET_SELLING_PRICE.REQUEST, {
    sellingPriceId, orgId, tenantId, skuId, quantity, page, limit,
  })

  /**
   *
   * @param getSellingPricesLoading
   * @return {{type: *}}
   */
  getSellingPricesLoading = (getSellingPricesLoading) => action(offerActionTypes.GET_SELLING_PRICE.LOADING, {
    getSellingPricesLoading,
  });

  /**
   * @param prices
   * @param selectedOffer
   * @return {{type: *}}
   */
  getSellingPricesSuccess = (prices) => action(offerActionTypes.GET_SELLING_PRICE.SUCCESS, {
    prices,
  })

  /**
   * @param payload
   * @param callback
   * @param getOffersAgain
   * @param skuId
   * @return {{type: *}}
   */
  createSellingPrice = (payload, callback) => action(offerActionTypes.CREATE_SELLING_PRICE.REQUEST, {
    payload,
    callback,
  })

  /**
   * @param createSellingPriceLoading
   * @param createOfferLoading
   * @return {{type: *}}
   */
  createSellingPriceLoading = (createSellingPriceLoading) => action(offerActionTypes.CREATE_SELLING_PRICE.LOADING, {
    createSellingPriceLoading,
  })

  /**
   * @param payload
   * @param callback
   * @param getOffersAgain
   * @param skuId
   * @return {{type: *}}
   */
  updateSellingPrice = (payload, callback) => action(offerActionTypes.UPDATE_SELLING_PRICE.REQUEST, {
    payload,
    callback,
  })

  /**
   * @param updateSellingPriceLoading
   * @return {{type: *}}
   */
  updateSellingPriceLoading = (updateSellingPriceLoading) => action(offerActionTypes.UPDATE_SELLING_PRICE.LOADING, {
    updateSellingPriceLoading,
  })

  // Archive Offer Price
  archiveOfferPrice = (payload, callback) => action(offerActionTypes.ARCHIVE_OFFER_PRICE.REQUEST, {
    payload,
    callback,
  })

  archiveOfferPriceLoading = (archiveOfferPriceLoading) => action(offerActionTypes.ARCHIVE_OFFER_PRICE.LOADING, {
    archiveOfferPriceLoading,
  })
}
export default new OfferActions();
